import React from 'react';
import StatusConfigEditor from '../components/StatusConfigEditor';

const StatusConfiguration = () => {
  return (
    <div className="status-configuration-page">
      <StatusConfigEditor />
    </div>
  );
};

export default StatusConfiguration;
